import { useEffect } from 'react';

import { IS_SERVER } from '@/renderer/utils/ssr';

import { initOta } from './otaUpdater';

/**
 * Kick off the OTA update check once per app launch (SPIKE, issue #1334).
 *
 * Mirrors `usePushRegistration`: a client-only, native-only side effect mounted
 * high in the tree. No-op on the web build and during SSR. Gated behind
 * `VITE_OTA_ENABLED` inside `initOta` so it changes nothing for prod until we
 * flip the flag on a test build.
 */
export default function useOtaUpdater() {
  useEffect(() => {
    if (IS_SERVER) {
      return;
    }
    void initOta();
  }, []);
}
